import { React, observer, css } from '../..';
import { TicketCardContent } from '../../../detail/components/ticket-card/ticketCard';
import SessionDate from './Date';

const SessionRate = observer(({ session, rate }) => {
    return (
        <TicketCardContent className={`order-summary-content `}>
            <div className={css['summary-ticket-item']}>
                <SessionDate date={session} />
            </div>
            <div className={css['summary-ticket-subitem']}>{rate}</div>
        </TicketCardContent>
    );
});

export default SessionRate;
